import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductChangeComponent } from './product-change.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    ProductChangeComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    CommonModule,
    RouterModule,
    
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatProgressSpinnerModule
  ],
  exports: [
    ProductChangeComponent
  ]
})
export class ProductChangeModule { }
